import { experienceMode } from './experience';
import { vibrationEnabled } from './settings';

type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type NotificationType = 'error' | 'success' | 'warning';

const feedback = (): TelegramHapticFeedback | undefined =>
  experienceMode() === 'reduced' || !vibrationEnabled() ? undefined : window.Telegram?.WebApp?.HapticFeedback;

const impact = (style: ImpactStyle): void => feedback()?.impactOccurred(style);
const notify = (type: NotificationType): void => feedback()?.notificationOccurred(type);

export const haptics = {
  answerTap: (): void => feedback()?.selectionChanged(),
  answerLocked: (): void => impact('rigid'),
  bothLocked: (): void => impact('medium'),
  matchReveal: (): void => notify('success'),
  differentReveal: (): void => impact('medium'),
  reactionSent: (): void => impact('light'),
  reactionReceived: (): void => impact('soft'),
  finalResult: (): void => impact('heavy'),
  arcadeTap: (): void => impact('light'),
  arcadeHit: (): void => impact('medium'),
  arcadeScore: (): void => notify('success'),
  arcadePerfect: (): void => impact('heavy'),
  arcadeFail: (): void => notify('warning')
} as const;

